import React from "react"
import {
  StatCardContainer,
  StatCardLabel,
  StatCardStat,
} from "./stat-card.styles"

const StatCard = ({ stat, isCommunityPage, ...props }) => {
  return (
    <>
      <StatCardContainer {...props} isCommunityPage={isCommunityPage}>
        <StatCardStat isCommunityPage={isCommunityPage}>{stat.value}</StatCardStat>
        <StatCardLabel isCommunityPage={isCommunityPage}>{stat.text}</StatCardLabel>
      </StatCardContainer>
    </>
  )
}

export default StatCard
